var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"page-login-wrap"}},[([1, 2, 3, 4].indexOf(_vm.roleId) > -1)?[_c('profileSttings')]:_vm._e(),(_vm.roleId == 50)?[_c('petitionerProfile')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }